import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  sectionContainer: {
  },
  img: {
    height: '115px',
    maxWidth: '100%',
  },
  imgContainer: {
    width: '400px',
  },
}));

export default useStyles;
